import React, { useEffect, useState, useContext, useRef } from "react";
import Flex from '@react-css/flex';
import { Multiselect } from 'multiselect-react-dropdown';
import InputMask from 'react-input-mask';
import Modal from 'react-modal';
import DatePicker, { registerLocale } from 'react-datepicker';
import { ToggleSwitch } from "../../components/ToggleSwitch";
import { StyledForm } from "../../styled-components/StyledForm.style";
import api from '../../services/api';
import Swal from "sweetalert2";
import TimeSheetDetalhesContext from "../../contexts/TimeSheetDetalhesContext";
import * as moment from 'moment'
import Select from 'react-select';

export const ModalTimeSheetDetalhes = ({
    atividades,
    location,
    peritosList,
    isOpen,
    setIsOpen,
    loadPage,
    isFromProjetoInterno
}) => {
    const [showAdvanceFood, setAdvanceFood] = useState(false);
    const [discountMeal, setDiscountMeal] = useState(true);
    var [horaFinal, setHoraFinal] = useState(null);
    var [horaInicio, setHoraInicio] = useState(null);
    var [descricao, setDescricao] = useState(null);
    var [idAtividade, setIdAtividade] = useState(null);
    var [desconto, setDesconto] = useState("00:00");
    var [descontoDecimal, setDescontoDecimal] = useState(null);
    var [meuTimesheet, setMeuTimesheet] = useState(true);
    const [showAdvanceTimesheet, setAdvanceTimesheet] = useState(true);
    var [idPeritos, setPeritosId] = useState([]);
    var [perito, setPerito] = useState(null);
    var [atividade, setAtividade] = useState(null);
    const [startAcitivitiesDate, setStartAcitivitiesDate] = useState(new Date());
    const multiselectRef = useRef();
    const { timesheet } = useContext(TimeSheetDetalhesContext);
    const [atividadeProBono, setAtividadeProBono] = useState(false);
    const [isSalvando, setIsSalvando] = useState(false);

    const style = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: "0px",
            minWidth: '35%',
            overflowY: 'auto',
            minHeight: '45%',
            maxHeight: '90%'
        },
        overlay: {
            zIndex: 9999
        }
    };

    const advanceFood = { name: 'advanceFood', label: 'Descontar Refeição' };
    const advanceTimesheet = { name: 'advanceTimesheet', label: 'Meu lançamento', status: true };
    const proBono = { name: 'proBono', label: 'Pro bono' };

    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Credentials': false
        }
    }

    const onGetPerito = (currentValue, value) => {
        let peritosList = [];

        perito = value.nome;
        setPerito(perito);

        currentValue.map(a => { peritosList.push(a.idUsuario) });
        idPeritos = peritosList;

        setPeritosId(peritosList);
    };

    const getAtividade = (atividade) => {
        if (!atividade) return

        setAtividade(atividade);
        setIdAtividade(atividade.id);
    };

    let atividadesFormatadas = [];
    const formatAtividades = () => {
        atividades.map(atividade => {
            var item = {
                "value": atividade.value,
                "id": atividade.key,
                "label": atividade.value
            };
            atividadesFormatadas.push(item);
        }
        );
    }
    formatAtividades();



    const validarData = (data) => {
        return moment(data, "YYYY-MM-DD", true).isValid();
    }


    const validarDataMaiorAtual = (data) => {
        return moment(data, "YYYY-MM-DD", true).isAfter(moment(), 'day');
    }




    const onRemovePerito = (currentValue, value) => { }
    const onAfterOpen = () => { };

    const closeModal = (event) => {
        if (event.type === 'keydown' && event.keyCode === 27) return
        setIsOpen(false);
    }

    const handleHoraFinal = (hora) => {
        horaFinal = hora;
        setHoraFinal(horaFinal);
    }

    const handleDesconto = (desconto) => {
        if(desconto === "") {
            desconto = "00:00";
        }
        setDesconto(desconto);
        formatDecimalTime(timeStringToDecimalHours(desconto));
    }


    const timeStringToDecimalHours = (timeString) => {
        if (!timeString) {
            return;
        }

        const [hours, minutes] = timeString.split(':').map(Number);
        const decimalHours = hours + (minutes / 60);
        return decimalHours;
    }


    const formatDecimalTime = (decValue) => {
        // if (!decValue) {
        //     return;
        // }
        setDescontoDecimal(decValue?.toFixed(2)?.replace(".", ",") ?? "");
    }


    const handleHoraInicial = (hora) => {
        horaInicio = hora;
        setHoraInicio(horaInicio);
    }

    const handleDescricao = (valor) => {
        descricao = valor;
        setDescricao(descricao);
    }

    const handleDateChange = (date) => {


        if (!validarData(date)) {
            registrationFailure("Data inválida!")
            return;
        }


        if (validarDataMaiorAtual(date)) {
            registrationFailure("Data não deve ser maior que a data atual!")
            return;
        }


        setStartAcitivitiesDate(date);
    }

    const mensagemProBono = (payload) => {
        Swal.fire({
            text: "Deseja realmente cadastrar esta atividade como Pro Bono?",
            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonText: "Sim",
            cancelButtonText: "Não",
        }).then(async (result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                Swal.showLoading()
                await api.post(`Timesheet/atividade`, payload)
                    .then(async (response) => {
                        loadPage();
                        setIsOpen(false);
                        registrationSuccess();
                    })
                    .catch((error) => {
                        registrationFailure(error?.response?.data?.notification?.messageReturn)
                    });
            }
        });
    };

    const salvarAtividade = async (payload) => {
        await api.post(`Timesheet/atividade`, payload)
            .then(async (response) => {
                loadPage();
                setIsOpen(false);
                registrationSuccess();
            })
            .catch((error) => {
                registrationFailure(error?.response?.data?.notification?.messageReturn)
            });
    }

    const formActivities = async () => {
        if (isSalvando) return;
        setIsSalvando(true);

        let descontofinal = "00:00";
        let idPeritosfinal = [];

        try {
            if (idAtividade != null
                && startAcitivitiesDate != null
                && horaInicio != null
                && horaFinal != null) {

                if (!meuTimesheet) {
                    idPeritosfinal = idPeritos;
                }

                //Valida hora inicial e final
                var dateInicio = new moment();
                dateInicio.set({
                    hour: horaInicio.target.value.split(":")[0],
                    minute: horaInicio.target.value.split(":")[1],
                    second: 0
                });

                var dateFim = new moment();
                dateFim.set({
                    hour: horaFinal.target.value.split(":")[0],
                    minute: horaFinal.target.value.split(":")[1],
                    second: 0
                });

                if (!dateInicio.isBefore(dateFim)) {
                    await registrationFailure("Hora inicial é maior que hora final!")
                    return;
                }

                if (validarDataMaiorAtual(startAcitivitiesDate)) {
                    await registrationFailure("Data não deve ser maior que a data atual!")
                    return;
                }

                let payload = {
                    idTimesheet: location.hash.replace("#", ''),
                    meuTimesheet: meuTimesheet,
                    peritos: idPeritosfinal,
                    idAtividade: idAtividade,
                    descricao: descricao?.target?.value || "",
                    dataLancamento: moment(startAcitivitiesDate).format('YYYY-MM-DD'),
                    horaInicio: horaInicio.target.value,
                    horaFinal: horaFinal.target.value,
                    descontarRefeicao: discountMeal,
                    timeDesconto: desconto,
                    proBono: atividadeProBono
                }

                if (desconto != null) {
                    descontofinal = desconto;
                
                    // Converte os horários de string para objetos Date para comparação
                    const inicio = new Date(`1970-01-01T${horaInicio.target.value}:00`);
                    const fim = new Date(`1970-01-01T${horaFinal.target.value}:00`);
                
                    // Define os intervalos de tempo
                    const intervalos = [
                        { inicio: new Date("1970-01-01T00:00:00"), fim: new Date("1970-01-01T08:00:00") },
                        { inicio: new Date("1970-01-01T11:00:00"), fim: new Date("1970-01-01T14:00:00") },
                        { inicio: new Date("1970-01-01T18:00:00"), fim: new Date("1970-01-01T22:00:00") }
                    ];
                
                    // Calcula a duração total da atividade em horas
                    const duracaoEmHoras = (fim - inicio) / (1000 * 60 * 60); // Converte de ms para horas
                
                    // Verifica se o horário de início ou fim está dentro de algum intervalo
                    const dentroDoIntervalo = intervalos.some(intervalo => 
                        (inicio >= intervalo.inicio && inicio < intervalo.fim) || 
                        (fim > intervalo.inicio && fim <= intervalo.fim)
                    );
                
                    // Se estiver dentro do intervalo, a duração for maior que 4 horas e não houver intervalo (desconto)
                    if (dentroDoIntervalo && descontofinal === "00:00" && duracaoEmHoras > 4) {
                        //Lembrete: Atividades lançadas entre 00h-08h, 11h-14h e 18h-22h devem conter um horário de intervalo se ultrapassarem 4 horas.
                        await registrationTimeInterval(payload);
                        return;
                    }
                }
                

                if (discountMeal) {
                    var diferenca = moment.duration(dateFim.diff(dateInicio));

                    var horasFinais = diferenca.subtract({
                        'hours': (descontofinal.split(":")[0].replace(/_/g, '0').padStart(2, '0')),
                        'minutes': (descontofinal.split(":")[1].replace(/_/g, '0').padStart(2, '0'))
                    })
                    if (horasFinais.asHours() < 0) {
                        await registrationFailure("Não é possível cadastrar uma atividade com horas negativas!")
                        return;
                    }
                }            

                if(atividadeProBono) {
                    mensagemProBono(payload);
                }
                else {
                    await salvarAtividade(payload);
                }
            }
            else {
                registrationInformation();
            }
        } finally {
            setIsSalvando(false);
        }
    };

    const getFoodModalToggle = (status) => {
        setAdvanceFood(status);
        setDiscountMeal(status);
    };

    const getTimesheetModalToggle = (status) => {
        setAdvanceTimesheet(status);
        setMeuTimesheet(status);
    };

    const getProBonoModalToggle = (status) => {
        setAtividadeProBono(status);
    };

    const registrationSuccess = () => {
        Swal.fire({
            title: "Sucesso",
            text: "Cadastro realizado com sucesso",
            icon: "success",
            showConfirmButton: false,
            timer: 2500,
        });
    }

    const registrationFailure = async (text = "Ops, ocorreu um erro ao realizar o cadastro. Tente novamente em instantes.") => {
        Swal.fire({
            title: "Atenção",
            text: text,
            icon: "error",
            confirmButtonText: "OK"
        });
    }

    const registrationInformation = async () => {
        Swal.fire({
            title: "Informação",
            text: "Preencha todos os campos necessários",
            icon: "info",
            confirmButtonText: "OK"
        });
    }

    const registrationTimeInterval = async (payload) => {
        const result = await Swal.fire({
            title: "Informação",
            text: "Não possui intervalo para o período informado?",
            icon: "info",
            showDenyButton: true,
            confirmButtonText: "Corrigir",
            denyButtonText: "Salvar sem intervalo",
        });

        if (result.isDenied) {
            if (atividadeProBono) {
                await mensagemProBono(payload);
            } else {
                await salvarAtividade(payload);
            }
        }
    };


    useEffect(() => {
        const asyncFn = async () => { setMeuTimesheet(true) }
        asyncFn()
    }, []);


    useEffect(() => {
        if (isOpen) {
            setAtividadeProBono(false)
            setDescricao(null);
        }

    }, [isOpen]);

    return (
        <Modal
            isOpen={isOpen}
            onAfterOpen={onAfterOpen}
            onRequestClose={closeModal}
            contentLabel="Timesheet Atividades"
            style={style}
            ariaHideApp={false}
            shouldCloseOnOverlayClick={false}
        >
            <StyledForm>
                <p className="modal-close" onClick={closeModal}>X</p>
            </StyledForm>
            <Flex>
                <Flex.Item className="modal-width">
                    <p className="modal-title">Lançamento de Atividade</p>
                </Flex.Item>
            </Flex>
            <Flex>
                <StyledForm>
                    <Flex>
                        <Flex.Item className="modal-width">
                            <div className="position-relative form-group">
                                <div>
                                    <p className="modal-info">Cliente </p>
                                    <p className="modal-info-data">{timesheet.cliente.clienteNome} </p>
                                    <p className="modal-info">Disciplina </p>
                                    <p className="modal-info-data">{timesheet.disciplina.seguradoNome}  </p>
                                    <p className="modal-info">Lider </p>
                                    <p className="modal-info-data">{timesheet.pericia.liderPericia}  </p>
                                </div>
                            </div>
                        </Flex.Item>
                        <Flex.Item className="modal-width">
                            <div className="position-relative form-group">
                                <div>
                                    <p className="modal-info">Nº do Timesheet</p>
                                    <p className="modal-info-data"> {timesheet.timesheet.numeroTimesheet} </p>
                                    <p className="modal-info">Segurado </p>
                                    <p className="modal-info-data">{timesheet.segurado.seguradoNome}  </p>
                                </div>
                            </div>
                        </Flex.Item>
                    </Flex>
                    <Flex>
                        <Flex.Item className="modal-width">
                            <div className="position-relative form-group">
                                <div className="form-wrapper filter-container">
                                    <div style={{ marginLeft: "0px" }} className="form-container flex-column justify-content-center">
                                        <ToggleSwitch config={advanceTimesheet} setStatus={(status) => getTimesheetModalToggle(status)} inicialStatus={true} />
                                    </div>
                                    { isFromProjetoInterno ??
                                        <div style={{ marginLeft: "0px" }} className="form-container flex-column justify-content-center">
                                            <ToggleSwitch config={proBono} setStatus={(status) => getProBonoModalToggle(status)} />
                                        </div>
                                    }
                                </div>
                            </div>
                        </Flex.Item>
                    </Flex>

                    <Flex className={!!showAdvanceTimesheet ? `display-none` : ``} style={{ width: '100%' }}  >
                        <div className={!!showAdvanceTimesheet ? `input-hide position-relative form-group` : `position-relative form-group`} style={{ width: '100%' }} >
                            <Multiselect
                                required='required'
                                placeholder={'Profissionais'}
                                showCheckbox="true"
                                options={peritosList} // Options to display in the dropdown
                                selectedValues={peritosList.selectedValue} // Preselected value to persist in dropdown
                                onSelect={onGetPerito} // Function will trigger on select event
                                onRemove={onRemovePerito} // Function will trigger on remove event
                                displayValue="nome" // Property name to display in the dropdown options
                                ref={multiselectRef}
                            />
                        </div>
                    </Flex>

                    <Flex>
                        <div style={{ width: '100%' }} className="position-relative form-group">
                            <Select
                                ref={multiselectRef}
                                isClearable={true}
                                className="basic-single"
                                placeholder={'Atividade'}
                                options={atividadesFormatadas}
                                onChange={getAtividade}
                            />
                        </div>
                    </Flex>

                    <Flex>
                        <div style={{ width: '100%' }} className="position-relative form-group">
                            <textarea rows="3" className="input-form" placeholder='Descrição' name='descricao' onBlur={handleDescricao} />
                        </div>
                    </Flex>

                    <Flex className="edit-atividade-timesheet">
                        <Flex.Item style={{ width: '100%', marginRight: '20px' }}>
                            <div className="position-relative form-group">
                                <DatePicker dateFormat="dd/MM/yyyy" locale="pt-BR" className="input-form" selected={startAcitivitiesDate} onChange={handleDateChange} />
                            </div>
                        </Flex.Item>
                        <div style={{ display: "inline" }}>
                            <Flex.Item style={{ width: '50%', float: "left" }}>
                                <div className="position-relative form-group">
                                    <InputMask autoComplete="off" mask="99:99" type='text' className="input-form" placeholder='Hora Inicial' name='HoraInicial' onBlur={handleHoraInicial} />
                                </div>
                            </Flex.Item>

                            <Flex.Item style={{ width: '50%', float: "left" }}>
                                <div className="position-relative form-group">
                                    <InputMask autoComplete="off" mask="99:99" type='text' className="input-form" placeholder='Hora Final' name='HoraFinal' onBlur={handleHoraFinal} />
                                </div>
                            </Flex.Item>
                        </div>
                    </Flex>

                    <Flex className="edit-atividade-timesheet">
                        <Flex.Item style={{ width: '59%', marginRight: '20px' }}>
                            <div className="form-group">
                                <span id="totalDescHoras" style={{ marginTop: '5px', lineHeight: '45px' }}>Descontar Intervalo</span>
                            </div>
                        </Flex.Item>
                        <div style={{ display: "inline" }}>
                            <Flex.Item style={{ width: '50%', float: "left" }}>
                                <div className="position-relative form-group">
                                    <InputMask autoComplete="off" mask="99:99" type='text' className="input-form" placeholder='Desconto' name='Desconto' value={desconto} onChange={(event) => setDesconto(event.target.value)} onBlur={(event) => handleDesconto(event.target.value)} />
                                </div>
                            </Flex.Item>

                            <Flex.Item style={{ width: '50%', float: "left" }}>
                                <div className="position-relative form-group">
                                    <span id="totalDescHoras" style={{ marginTop: '5px', marginLeft: '25px', lineHeight: '45px' }}>{descontoDecimal}</span>
                                </div>
                            </Flex.Item>
                        </div>
                    </Flex>

                    <Flex className="full-width">
                        <Flex.Item className="modal-width">
                            <div className="position-relative form-group modal-align-center">
                                <button
                                    className="default-button-red"
                                    onClick={formActivities}
                                    disabled={isSalvando}
                                >
                                {isSalvando ? "Salvando..." : "Adicionar Atividade"}
                                </button>
                            </div>
                        </Flex.Item>
                    </Flex>
                </StyledForm>
            </Flex>
        </Modal>);
};
